import React from 'react';
import { Queue } from '../../../types/models/queue';
import styled from 'styled-components';
import StatusLed from '../../../components/widgets/status-led';
import { lightColors } from '../../../themes/colors';
import { DateAttr } from '../../../components/date-attr';

const ListItem = styled.li`
  display: grid;
  grid-template-columns: 2em 2em 1fr 2fr 1fr;
  grid-gap: 1em;
  align-items: center;
  span.led {
    cursor: pointer;
    display: inline-block;
    height: 13px;
    width: 13px;
    border-radius: 50%;
  }
  span.led-red {
    background-color: ${lightColors.red};
  }
  span.led-green {
    background-color: ${lightColors.green};
  }
`;

interface QueueItemProps {
  queue: Queue;
}

export function QueueItem(props: QueueItemProps) {
  return (
    <>
      <ListItem>
        <StatusLed greenStatusName="open" redStatusName="closed" status={props.queue.queueState} />
        <span>{props.queue.queueNumber}</span>
        <span>{props.queue.queueName}</span>
        <span>{props.queue.serviceProviderName}</span>
        <DateAttr date={props.queue.lastEnqueueDate} />
      </ListItem>
    </>
  );
}
